<template>
  <div class="safety-verify-container">
    <div class="safety-box">
      <van-icon name="info" color="#2774e9" size="50px" />
      <div class="safety-box-title">
        {{ $t("safety-title") }}
      </div>
      <div class="safety-box-tip">
        {{ $t("safety-tip") }}
      </div>
      <VerifySlider
        :tips="$t('slider-text')"
        :successTips="$t('slider-success')"
        @success="verifySuccess"
        ref="safetyVerify"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    verifySuccess(e) {
      var expireMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);
      this.$cookie.set("verify", "true", { expires: expireMinutes });
      location.reload()
    },
  },
};
</script>

<style lang="scss">
.safety-verify-container {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  padding: 0 20px;
  .safety-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &-title {
      font-weight: bold;
      margin-top: 20px;
      text-align: center;
    }
    &-tip {
      text-align: center;
      margin-top: 20px;
      font-size: 14px;
      line-height: 1.5;
    }
    .drag {
      margin-top: 20px;
    }
  }
}
</style>